import { useNavigate } from "react-router-dom";

export function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur z-50 shadow-sm">
        <div className="container mx-auto px-5 py-3 flex items-center justify-between">
          <img src="/img/logo.png" alt="Gran Arquitectura" className="h-11" />
          <button
            onClick={() => navigate("/login")}
            className="bg-primary hover:bg-primary-dark text-white px-5 py-2 rounded-lg font-semibold transition"
          >
            Iniciar Sesión
          </button>
        </div>
      </nav>

      <section className="pt-32 pb-20 text-center container mx-auto px-5">
        <h1 className="text-5xl font-serif font-bold text-slate-900 mb-4">
          Diseñamos <span className="text-primary">espacios</span> que inspiran
        </h1>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-8">
          Innovación arquitectónica con más de 20 años de experiencia.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="bg-primary hover:bg-primary-dark text-white px-8 py-3 rounded-lg font-semibold text-lg transition"
        >
          Acceder al Portal
        </button>
      </section>
    </div>
  );
}